webpackJsonp([159849449761359],{

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = BoldText;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BoldText(_ref) {
	  var copy1 = _ref.copy1,
	      emphasise = _ref.emphasise,
	      copy2 = _ref.copy2;
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    copy1,
	    ' ',
	    _react2.default.createElement(
	      'span',
	      { className: 'fontWeight-6' },
	      emphasise
	    ),
	    ' ',
	    copy2
	  );
	}
	
	BoldText.propTypes = {
	  copy1: _propTypes2.default.string,
	  emphasise: _propTypes2.default.string,
	  copy2: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoldText = __webpack_require__(523);
	
	var _BoldText2 = _interopRequireDefault(_BoldText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ebookData = [_react2.default.createElement(_BoldText2.default, {
	  copy1: 'New ways to ',
	  emphasise: 'drive design understanding and critique',
	  copy2: 'throughout your team'
	}), _react2.default.createElement(_BoldText2.default, {
	  copy1: 'The',
	  emphasise: 'impact of inconsistency',
	  copy2: 'in design handover and the key sources to look out for'
	}), _react2.default.createElement(_BoldText2.default, {
	  emphasise: 'Methods of ensuring consistency,',
	  copy2: 'touching on design systems and opening up the design process'
	}), _react2.default.createElement(_BoldText2.default, {
	  emphasise: 'The essential moments to check in with developers',
	  copy2: 'during the design process'
	})];
	exports.default = ebookData;
	module.exports = exports['default'];

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _booklet012x = __webpack_require__(2727);
	
	var _booklet012x2 = _interopRequireDefault(_booklet012x);
	
	var _booklet022x = __webpack_require__(2728);
	
	var _booklet022x2 = _interopRequireDefault(_booklet022x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  hero: {
	    alt: 'WorkBook',
	    src: _booklet012x2.default,
	    hasShadow: false
	  },
	  second: {
	    alt: 'WorkBook for Enterprise',
	    src: _booklet022x2.default,
	    hasShadow: false
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 2727:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/booklet-01@2x-4ad4cfa2e577952be77b65ce7d6c05fa.png";

/***/ }),

/***/ 2728:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/booklet-02@2x-91eb15144c265692ab3acb638e9edd4d.png";

/***/ }),

/***/ 1313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Workshops;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _TickedCopy = __webpack_require__(95);
	
	var _TickedCopy2 = _interopRequireDefault(_TickedCopy);
	
	var _WebinarForm = __webpack_require__(467);
	
	var _WebinarForm2 = _interopRequireDefault(_WebinarForm);
	
	var _workshop = __webpack_require__(1250);
	
	var _workshop2 = _interopRequireDefault(_workshop);
	
	var _hubspot = __webpack_require__(46);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _ebook = __webpack_require__(615);
	
	var _ebook2 = _interopRequireDefault(_ebook);
	
	var _generalModule = __webpack_require__(1509);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _LandingPagesWrap = __webpack_require__(67);
	
	var _LandingPagesWrap2 = _interopRequireDefault(_LandingPagesWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workshops = _metadata2.default.resources.workshops;
	
	var meta = {
	  title: workshops.title,
	  meta: [{
	    name: 'description',
	    content: workshops.description
	  }],
	  header: false,
	  footer: true
	};
	
	var messaging = {
	  header: _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', size: 'xs', position: 'bottom' },
	    _react2.default.createElement(
	      _heading2.default,
	      { tag: 'h1', size: 'xxl', weight: 'semibold' },
	      'Download the kit, for free!',
	      ' '
	    )
	  ),
	  copy: _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', size: 'l', position: 'bottom' },
	    _react2.default.createElement(
	      _paragraph2.default,
	      { size: 'm', color: 'silver' },
	      'Simply fill out the form below to get your hands on the Workbook, Facilitator Guide, Workshop Slides and Presentation Template Slides.'
	    )
	  )
	};
	
	function Workshops() {
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(
	      _LandingPagesWrap2.default,
	      { color: 'black' },
	      _react2.default.createElement(
	        'div',
	        {
	          id: 'enterprise-form',
	          style: { backgroundColor: '#FFDFF2', overflow: 'hidden' }
	        },
	        _react2.default.createElement(
	          _pageWrap2.default,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'xl', position: 'top', type: 'padding' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'xl', position: 'topBottom', type: 'padding' },
	              _react2.default.createElement(
	                _grid2.default,
	                { columns: 12, alignContent: 'center' },
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6 },
	                  _react2.default.createElement(
	                    _spacing2.default,
	                    { type: 'margin', size: 's', position: 'bottom' },
	                    _react2.default.createElement(_HeadingBlock2.default, {
	                      justifyM: 'start',
	                      headingSize: 'xxxxl',
	                      paragraphSize: 'xxl',
	                      paragraphMaxWidth: 600,
	                      headingMaxWidth: 450,
	                      title: 'The Design Thinking Workshop Kit',
	                      copy: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Empower everyone in your business to solve problems, together.'
	                      )
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _generalModule2.default.imageEbook },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _generalModule2.default.imageSpacing },
	                      _react2.default.createElement(_Image2.default, _extends({}, _workshop2.default.hero, { useImageTag: true }))
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _spacing2.default,
	                    { type: 'padding', position: 'topBottom', size: 'm' },
	                    _react2.default.createElement(_HeadingBlock2.default, {
	                      justifyM: 'start',
	                      headingSize: 'xxl',
	                      paragraphMaxWidth: 600,
	                      headingMaxWidth: 450,
	                      title: 'Run your first Design Thinking session',
	                      copy: _react2.default.createElement(
	                        'span',
	                        null,
	                        'This Workshop Kit will give you and your team a simple, inclusive and reusable approach for running sessions using the basic principles of Design Thinking. Learn how to apply the stages empathise, define, ideate, prototype and test to any problem, in an interactive and fun session.'
	                      )
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6, fullWidth: true },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _generalModule2.default.formPosition },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _generalModule2.default.border },
	                      _react2.default.createElement(
	                        'div',
	                        { className: _generalModule2.default.formPadding },
	                        _react2.default.createElement(_WebinarForm2.default, {
	                          headerTitle: messaging.header,
	                          headerText: messaging.copy,
	                          btnColor: 'blue',
	                          ctaCopy: 'Get Workshop Kit',
	                          infoMessage: 'This one\'s on us!',
	                          hubspotId: _hubspot.formEbook,
	                          url: '/resources/download-design-thinking-workshop-kit',
	                          disallowedFields: ['phoneNumber']
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _grid2.default,
	                { columns: 12 },
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6 },
	                  _react2.default.createElement(
	                    _maxWidth2.default,
	                    { value: 600 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'paddingTop-l' },
	                      _react2.default.createElement(
	                        _spacing2.default,
	                        { type: 'margin', position: 'topBottom', size: 'm' },
	                        _react2.default.createElement(
	                          _heading2.default,
	                          { tag: 'h2', size: 'xxl', weight: 'semibold' },
	                          'Made to help you:'
	                        )
	                      )
	                    ),
	                    _ebook2.default.map(function (item) {
	                      return _react2.default.createElement(
	                        _spacing2.default,
	                        { type: 'padding', position: 'bottom', size: 's' },
	                        _react2.default.createElement(
	                          _TickedCopy2.default,
	                          {
	                            isCentered: false,
	                            key: item.id,
	                            size: 'l',
	                            shouldShowBlackTick: true
	                          },
	                          item
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _generalModule2.default.imageEbookTwo },
	                    _react2.default.createElement(
	                      _spacing2.default,
	                      { type: 'margin', position: 'bottom', size: 'l' },
	                      _react2.default.createElement(_Image2.default, _extends({}, _workshop2.default.second, { useImageTag: true }))
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1509:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"border":"src-pages-workshops-style----general-module---border---3mCPL bg-white padding-m borderRadius-l","imageSpacing":"src-pages-workshops-style----general-module---imageSpacing----BIVB paddingTopBottom-m marginTopBottom-xs breakPointM-paddingTopBottom-l breakPointM-marginTopBottom-l","formPosition":"src-pages-workshops-style----general-module---formPosition---3BAu7 padding-0 breakPointS-padding-l marginLeft-0 breakPointM-marginLeft-xl","formPadding":"src-pages-workshops-style----general-module---formPadding---2iDGd padding-0 breakPointS-padding-l","imageEbook":"src-pages-workshops-style----general-module---imageEbook---2BMTY","imageEbookTwo":"src-pages-workshops-style----general-module---imageEbookTwo---1_P5p","infoMessage":"src-pages-workshops-style----general-module---infoMessage---6hFCd position-absolute pinBL paddingTop-s paddingRight-m marginBottom-xs bg-white"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-workshops-index-js-719967f93a2495e35486.js